/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */

import { BASE_PATH } from 'variables';

export const BASE_PATH_URL = '/' + BASE_PATH;

// Routes
export enum RouteTypes {
  LOGIN = '/login',
  HOME = '/home',
  CHANGE_PROFILE = '/changeProfile',
  PRACTICES_ALUMN_COURSE = '/home/:cursoId?/:idAlumn?',
  AUDIT = '/audit',
  VALIDATION_PHOTOS = '/validation-photos',
  CREATE = '/create-practice',
  DETAIL = '/practice/detail/:id',
  DETAIL_NO_PARAM = '/practice/detail',
  ALUMNS = '/listado-alumnos/:cursoId/:nombreCurso?',
  PRACT_ALU_CURSO = '/practicas-alumno-curso/:cursoId?/:idAlumn?',
  // DETAIL_ALUMN_BYCOURSE = '/practicas-alumno-curso/:cursoId?/:idAlumn?/:idPractica?',
  COURSE = '/listado-cursos',
  REPORT_COURSES_CLOSING = '/informe-cursos-cierre',
  PROFILE = '/profile',
  REPORT_HOURS = '/informe-horas',
  REPORT_HOURS_INSTRUCTOR = '/informe-horas-instructor',
  PRACT_HOURS_INSTRUCTOR = '/informe-horas-instructor/:idInstructor?/:anyo?/:mes?',
  REPORT_INFRAESTRUCTURE = '/informe-infraestructura',
  ALTA_ADMINISTRADORES = '/altaAdministradores',
  ALTA_SUPERVISORES = '/altaSupervisores',
  ALTA_VISUALIZADORES = '/altaVisualizadores',
  ALTA_GESTORES = '/altaGestores',
  ALTA_FORMADORES = '/altaFormadores',
  ALTA_ALUMNOS = '/altaAlumnos',
  CERTIFICADOS_PRACTICAS = '/certificadosPracticas',

}

// Requests
export enum RequestStatusTypes {
  Default,
  Loading,
  Success,
  Error,
}

export const GRANT_TYPE = 'password';
export const TOKEN_TYPE_HINT = 'access_token';

// Texts
export enum TxtTypes {
  TXT_DEFAULT_MESSAGE_ERROR = 'System connections could not be established. Try again later.',
  TXT_LOGIN_INPUT_ERROR = 'El usuario o la contraseña es incorrecta, por favor inténtelo de nuevo más tarde',
  TXT_LOGIN_FORBIDDEN_ACCESS = 'No puede acceder a la aplicación debido a su perfil',
  TXT_CLAIM_SMS_MESSAGE = 'Aviso Gestión Prácticas: El alumno {{id_alumno}} le ha remitido la ficha del día {{fecha_jornada}}. Ruego valide lo antes posible',
}

export enum LiteralHeadersTableTitles {
  CURSO = 'Curso',
  INICIO_SERVICIO = 'Inicio Serv.',
  FIN_SERVICIO = 'Fin Serv.',
  MINUTOS = 'Minutos',
  TIPO_PRACTICA = 'Tipo de práctica',
  RUTA = 'Ruta',
  ESTACION_INICIO = 'Estación Inicio',
  ESTACION_FIN = 'Estación fin',
  TREN = 'Tren',
  MORE_INFORMATION = 'Más información',
  INFORMATION_TRAIN = 'Información Tren',
  HORA_PUESTA_DISP = 'Hora Puesta Disp.',
  FECHA_INI_JORNADA = 'Fecha Ini Jor.',
  FECHA_FIN_JORNADA = 'Fecha Fin Jor.',
  HORA_INI_JORNADA = 'Hora Ini Jor.',
  HORA_FIN_JORNADA = 'Hora Fin Jor',
  TOTAL_JORNADA =  'Total Jor.',
  TIPO_USUARIO = 'Tipo Usuario',
  TIPO_EXTERNO = 'Tipo Externo',
  VEHICULO = 'Vehículo',
  TURNO = 'Turno',
  ALUMNO = 'Alumno',
  //Matricula Alumno
  ID_ALUMNO = 'Matricula Alumno',
  //Alumno nombre
  ALUMNO_NOMBRE = 'Nombre Alumno',
  //Alumno tooltip
  ALUMNO_TOOLTIP = 'Información Alumno',
  TIPO_ALUMNO = 'Tipo Alumno',
  NOMBRE_PERFIL = 'Perfil Alumno',
  TIPO_PERFIL = 'Perfil',
  INSTRUCTOR = 'Instructor',
  //Matricula Instructor
  ID_INSTRUCTOR = 'Matricula Instructor',
  //Instrucor nombre
  INSTRUCTOR_NOMBRE = 'Nombre Instructor',
  //Instructor tooltip
  INSTRUCTOR_TOOLTIP = 'Información Instructor',
  ESTADO = 'Estado',
  SELECCIONAR = 'Selec',
  VER = 'Ver',
}

export enum SortingSort {
  LOWER_TO_HIGH = 'asc',
  HIGH_TO_LOWER = 'desc',
}

export enum SortBy {
  FECHA_INI_SERVICIO = 'FECHA_INI_SERVICIO',
  FECHA_FIN_SERVICIO = 'FECHA_FIN_SERVICIO',
}
